module.exports = __webpack_public_path__ + "static/media/Magcargo_gaussian2.2965aa9b.png";